/* eslint-disable react/prop-types */
import React, { SyntheticEvent } from 'react';
import { ButtonToolbar, ButtonGroup, Button, DropdownItem } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CustomDropDown from './CustomDropDown';
import { OptionButton } from '../../services/types/Misc';

interface Props {
  id?: string;
  className?: string;
  elements: OptionButton[];
  value: number;
  subValue?: number;
  onChange: (value: number, subValue?: number) => void;
  disabled?: boolean;
}

const ButtonBar: React.FC<Props> = ({
  id,
  className,
  elements,
  value,
  subValue,
  onChange,
  disabled,
}) => {
  const renderSubItems = (optionId: number, options: OptionButton[]) =>
    options.map((option) => {
      const { subItemsCallback } = option;

      const handleSubItemClick = (e: SyntheticEvent) => {
        e.preventDefault();
        onChange(optionId, option.id);
      };

      const handleSubItemCallbackClick = (e: SyntheticEvent) => {
        e.stopPropagation();
        if (subItemsCallback) {
          subItemsCallback(option.id, option.text);
        }
      };

      return (
        <DropdownItem
          key={`${optionId}_${option.id}`}
          active={subValue === option.id}
          onClick={handleSubItemClick}
        >
          {option.text}
          {subValue === option.id && <FontAwesomeIcon icon="check" />}
          {subItemsCallback && (
            <FontAwesomeIcon icon="trash-alt" onClick={handleSubItemCallbackClick} />
          )}
        </DropdownItem>
      );
    });

  const button = (option: OptionButton) =>
    !option.subItems ? (
      <Button
        id={option.htmlId}
        color="nothing"
        key={option.id}
        onClick={() => onChange(option.id)}
        className={value === option.id ? 'active' : ''}
        disabled={disabled}
      >
        {option.icon && <FontAwesomeIcon icon={option.icon} />}
        {option.noWrapText ? (
          <span style={{ whiteSpace: 'nowrap' }}>{option.text}</span>
        ) : (
          option.text
        )}
      </Button>
    ) : (
      <CustomDropDown
        key={option.id}
        text={option.text}
        color="nothing"
        outline={false}
        active={value === option.id}
      >
        {renderSubItems(option.id, option.subItems)}
      </CustomDropDown>
    );

  return (
    <ButtonToolbar className={className} id={id}>
      <ButtonGroup>{elements.map((option) => button(option))}</ButtonGroup>
    </ButtonToolbar>
  );
};

export default React.memo(
  ButtonBar,
  (prevProps, nextProps) =>
    prevProps.value === nextProps.value &&
    prevProps.subValue === nextProps.subValue &&
    prevProps.elements === nextProps.elements
);
